import { GetSidebarItemFn } from "@/components/layout/Sidebar/sidebar.types";
import { sidebarViewMap } from "@/features/views/sidebar-items/sidebar-view-map";
import type { View } from "@/features/views/view-definitions";
import { useAppSelector } from "@/store";

const isView = (view: string): view is View => view in sidebarViewMap;

export const useViewSidebarItems = (): GetSidebarItemFn[] => {
    const activeView = useAppSelector((state) => state.user.activeView);

    if (!activeView || !isView(activeView)) return [];

    return sidebarViewMap[activeView];
};
